import { brandedString } from 'src/helpers/brandedString';

// @todo: Ideally schema would expose them
export const TenantCreateActions = brandedString({
  CREATE_TENANT: 'tenant-management:tenant.create',
});
